import { MemberLeaderboardPage } from '@/pages/crm/chain/MemberLeaderboardPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

// The time window lives in URL state so a ranking is shareable by link (AC43). `from`/`to` are
// ISO dates; absent means the server's last-90-days default.
const leaderboardSearchSchema = z.object({
	from: z.string().optional(),
	to: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_app/crm/chain/members')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({
			context,
			anyOf: ['chainDistribution.readLeaderboard'],
			redirectTo: '/dashboard',
		}),
	component: MemberLeaderboardPage,
	validateSearch: leaderboardSearchSchema,
});
